import axios from 'axios'
import store from '@/store'

export default {
  setupInterceptors() {
    axios.interceptors.response.use(
      response => response,
      error => {
        if (!store.state.user.currentUser) return;
        if (error.response.data.message) {
          const getErrorType = this.getErrorType();
          if (getErrorType === 'idtfReview') return;
          const errorMessage = error.response.data.message === 'no data.'
          ? '這個頁面已經不存在囉！這筆資料可能已被人刪除。'
          : '發生錯誤。';
          store.dispatch("error/setNoData", true);
          store.dispatch("error/setErrorMessage", errorMessage);
        }
        return Promise.reject(error)
      }
    )
  },
  getErrorType({
    status,
    data: {message},
    config: {url}
  }) {
    if (
      (url.includes('act_cnt_reivew/complete') ||
      url.includes('idtf_update/complete') ||
      url.includes('idtf_review/complete') ||
      url.includes('overall_review/complete')) &&
      status === 400 && message === 'complete failed') {
      return 'idtfReview';
    }
    return '';
  }
}